
// Action Types
export const NOMINEE_ACTIONS = {
  SET_NOMINEE_DATA: 'SET_NOMINEE_DATA',
  UPDATE_NOMINEE_FIELD: 'UPDATE_NOMINEE_FIELD',
  RESET_NOMINEE_DATA: 'RESET_NOMINEE_DATA',
  SET_NOMINEE_LOADING: 'SET_NOMINEE_LOADING',
  SET_NOMINEE_ERRORS: 'SET_NOMINEE_ERRORS',
  CLEAR_NOMINEE_ERRORS: 'CLEAR_NOMINEE_ERRORS',
};

// Initial State
const initialState = {
  nomineeData: {
    insurance_id: '',
    firm_owner_name: '',
    id_type: '',
    id_number: '',
    full_name: '',
    dob: '',
    age: '',
    phone_number: '',
    relation: '', // Extra field for nominee
    confirm: false,
    firm_type: '',
    gender: 'MALE', // Set default gender instead of empty string
  },
  loading: false,
  errors: {},
  isImageUpdated: false,
  compressedSize: 0,
  isCompressing: false,
};

// Action Creators
export const setNomineeData = (data) => ({
  type: NOMINEE_ACTIONS.SET_NOMINEE_DATA,
  payload: data,
});

export const updateNomineeField = (field, value) => ({
  type: NOMINEE_ACTIONS.UPDATE_NOMINEE_FIELD,
  payload: { field, value },
});

export const resetNomineeData = () => ({
  type: NOMINEE_ACTIONS.RESET_NOMINEE_DATA,
});

export const setNomineeLoading = (loading) => ({
  type: NOMINEE_ACTIONS.SET_NOMINEE_LOADING,
  payload: loading,
});

export const setNomineeErrors = (errors) => ({
  type: NOMINEE_ACTIONS.SET_NOMINEE_ERRORS,
  payload: errors,
});

export const clearNomineeErrors = () => ({
  type: NOMINEE_ACTIONS.CLEAR_NOMINEE_ERRORS,
});

// Reducer
const nomineeReducer = (state = initialState, action) => {
  switch (action.type) {
    case NOMINEE_ACTIONS.SET_NOMINEE_DATA:
      return {
        ...state,
        nomineeData: {
          ...state.nomineeData,
          ...action.payload,
        },
      };

    case NOMINEE_ACTIONS.UPDATE_NOMINEE_FIELD:
      return {
        ...state,
        nomineeData: {
          ...state.nomineeData,
          [action.payload.field]: action.payload.value,
        },
      };

    case NOMINEE_ACTIONS.RESET_NOMINEE_DATA:
      return {
        ...state,
        nomineeData: {
          ...initialState.nomineeData,
        },
        errors: {},
        isImageUpdated: false,
        compressedSize: 0,
      };

    case NOMINEE_ACTIONS.SET_NOMINEE_LOADING:
      return {
        ...state,
        loading: action.payload,
      };

    case NOMINEE_ACTIONS.SET_NOMINEE_ERRORS:
      return {
        ...state,
        errors: action.payload,
      };

    case NOMINEE_ACTIONS.CLEAR_NOMINEE_ERRORS:
      return {
        ...state,
        errors: {},
      };

    case 'RESET_BENEFICIARY_NOMINEE':
      return {
        ...initialState,
      };

    default:
      return state;
  }
};

export default nomineeReducer;